import { CHECK_LOGIN, LOGIN_USER_SUCCESSFUL, API_ERROR, LOGOUT_USER, LOGOUT_USER_SUCCESS, VERIFY_ADMIN_SUCCESS, VERIFY_ADMIN_FAIL, RESET_STATE, REGISTER_USER_SUCCESS, REGISTER_USER_FAIL } from './actionTypes';

const initialState = {
    registerRes: [],
    error: {},
}
const Register = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER_USER_SUCCESS:
            return {
                ...state,
                registerRes: action.payload
            }
        case REGISTER_USER_FAIL:
            return {
                ...state,
                error: action.payload,
                registerRes: action.payload
            }
        case RESET_STATE:
            state = initialState;
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
}

export default Register;